import axios, { AxiosError } from "axios";

import { Questionnaire } from "@teamprevent/common/questionnaires/model";

const buildUrl = () => "/api/employeeSatisfactionSurvey";

const loadQuestionnaire = async (customerId: string, taskId: string) => {
    try {
        const response = await axios.get<Questionnaire>(`${buildUrl()}/${customerId}/${taskId}`);
        return response.data;
    } catch (ex) {
        const axiosError = ex as AxiosError;
        if (axiosError?.response?.status === 400) {
            const error = { message: axiosError?.response?.data, status: 400 };
            throw error;
        }
        else if (axiosError?.response?.status === 404) {
            return null;
        }

        throw ex;
    }
};

export const employeeSatisfactionSurveyApi = { loadQuestionnaire };
